export const config = {
    development: true
}